const JOB_TITLE_LABELS: Record<string, string> = {
  admin: "Admin",
  account_manager: "Account Manager",
  sales_head: "Sales Head",
  sales_admin: "Sales Admin",
  project_manager: "Project Manager",
  presales: "Presales",
  finance: "Finance",
  legal: "Legal",
  operations: "Operations",
  view_only: "View Only",
};

export function formatJobTitleLabel(value?: string | null) {
  if (!value) return "No Job Title";

  const normalized = value.trim();
  if (!normalized) return "No Job Title";

  return (
    JOB_TITLE_LABELS[normalized.toLowerCase()] ||
    normalized
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())
  );
}
